/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
2/11/2021 Cristian Andres Pizo Mina – Se modifico las direcciones de /Stactic y /Vacation.
================================================================================ */

export const MenuItems = [
    {
        label: 'Horas extra y recargos',
        url: '/NoveltiesOvertime',
        index: 0,
    },
    {
        label: 'Reportados',
        url: '/NoveltiesReported',
        index: 1,
    },
    {
        label: 'Fijas',
        url: '/NoveltiesStatic',
        index: 2,
    },
    {
        label: 'Vacaciones',
        url: '/NoveltiesVacation',
        index: 3,
    },
    {
        label: 'Ausentismos y licencias',
        url: '/NoveltiesLicenses',
        index: 4,
    }
]